import React from 'react';
import '../styling/componentStyles.css'

export const Label: React.FC = () =>{
    
        return (
            <div className='footer'>
                <div className='leftText'>{new Date().getFullYear()} Pidilite Industries Ltd.</div>
                <div className='rightText'>1800-266-6066</div>
            </div>
        )
    }

export default Label